export const COLOR = "#1e6286";
export const WARNING = "#C72223";
